import { CookieClearOptions } from '../../types/interface';

export function getCookie(cname: string) {
  const decodedCookie = decodeURIComponent(document.cookie);
  let cookie = undefined;
  decodedCookie
    .split(';')
    .map(ck => ck.trim())
    .forEach(ck => {
      const [ckKey, ckValue] = ck.split('=');
      if (ckKey === cname) cookie = ckValue;
    });

  return cookie;
}
export function setCookie(cname: string, cvalue: string, exdays = 0.3) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=';
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function clearCookie(cname: string) {
  setCookie(cname, '', -1);
}

export function clearSubDomainCookie(
  cookieName: string,
  options: CookieClearOptions = {}
): void {
  const {
    domain = getDomainFromCurrentUrl(),
    path = '/',
    secure = false,
    sameSite
  } = options;

  // Build the cookie clearing string
  let cookieString = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`;

  if (domain) {
    cookieString += `; domain=${domain}`;
  }

  if (secure) {
    cookieString += '; Secure';
  }

  if (sameSite) {
    cookieString += `; SameSite=${sameSite}`;
  }

  document.cookie = cookieString;
}

export function getDomainFromCurrentUrl(): string {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // For localhost or IP addresses, return as is
  if (parts.length <= 2 || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return hostname;
  }

  // Return root domain with dot prefix for subdomains
  return `.${parts.slice(-2).join('.')}`;
}
